<div class="common-padding pn-page">
  <div class="heading p-0 mt-3 mb-4">
    <span class="span-create-edit-hoshin color">SENT NOTIFICATIONS</span>
    <div class="d-flex align-items-center pn-header-actions">
      <button type="button" class="btn btn-toyota-outline" (click)="refreshLogs()" [disabled]="logsLoading">Refresh</button>
      <a class="btn btn-danger btn-style" routerLink="/push-notification">Back to compose</a>
    </div>
  </div>

  <!-- <p class="pn-loading-state" *ngIf="logsLoading" role="status" aria-live="polite">Loading notifications…</p> -->

  <div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="timeOutError">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">{{ timeoutErrorMessage }}</span>
    <button type="button" class="btn btn-toyota-outline pn-retry" (click)="getpushNotificationLogsDataList()">Retry</button>
  </div>

  <div class="pn-empty-state" *ngIf="noDataFound && !logsLoading">
    <i class="fa fa-bell-slash pn-empty-icon" aria-hidden="true"></i>
    <p class="noDataFound">No notification records found</p>
    <p class="pn-empty-hint">Your notification history will appear here. Missing records do not confirm that a previous send failed.</p>
  </div>

  <div class="pn-table-card" *ngIf="tableShow" [attr.aria-busy]="logsLoading">
    <div class="pn-table-scroll">
      <table class="pn-table" id="tabledemo">
        <caption class="sr-only">Push notification logs with sender, date, subject, recipients, attachments, and preview actions</caption>
        <thead>
          <tr>
            <th scope="col" title="Sent By">Sent By</th>
            <th scope="col" title="Sent At">Sent At</th>
            <th scope="col">Subject</th>
            <th scope="col" title="Recipients" class="text-center">Recipients</th>
            <th scope="col" title="Attachments" class="text-center">Attachments</th>
            <th scope="col" title="Action" class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of pushNotificationLogsDataList | paginate: { itemsPerPage: limit, currentPage: currentPage, totalItems: numberOfElements }">
            <td class="pn-nowrap">{{data.userName}}</td>
            <td class="pn-nowrap" [title]="data.sentAt">
              {{data.sentAt}}
              <!-- Reserved for future use when time information is supported by the backend. -->
              <!-- <span class="pn-time-unavailable" *ngIf="!data.sentTimeAvailable && data.sentAt !== 'Date unavailable'">Time not provided</span> -->
            </td>
            <td class="pn-subject-cell" [title]="data.subject">{{data.subject}}</td>
            <td class="text-center">{{data.emailsArr?.length || 0}}</td>
            <td class="text-center">{{data.attachmentList?.length || 0}}</td>
            <td class="text-center">
              <button type="button" class="pn-view-button" (click)="viewNotification(data)"
                [attr.aria-label]="'View ' + data.subject" title="View">
                <img src="assets/images/view.png" class="pn-view-icon" alt="">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="bpgpagination" class="pn-table-footer">
      <span>Showing {{firstShowingElement}}&ndash;{{lastShowingElement}} of {{numberOfElements}} results</span>
      <pagination-controls *ngIf="numberOfElements > limit" previousLabel="Prev" nextLabel="Next"
        (pageChange)="pageChanged($event)"></pagination-controls>
    </div>
  </div>
</div>

<ng-template #notificationDetailsDialog>
  <div class="pn-dialog pn-log-dialog" *ngIf="selectedNotification">
    <div class="pn-dialog-header">
      <div class="pn-dialog-heading">
        <span class="pn-dialog-heading-icon" aria-hidden="true"><i class="fa fa-envelope"></i></span>
        <div>
          <h2 class="pn-dialog-title" id="notification-preview-title">Notification details</h2>
          <p class="pn-dialog-subtitle mb-0">
            Recorded {{selectedNotification.sentAt}}
            <!-- Reserved for future use when time information is supported by the backend. -->
            <!-- <span *ngIf="!selectedNotification.sentTimeAvailable && selectedNotification.sentAt !== 'Date unavailable'">(time not provided)</span> -->
            by {{selectedNotification.userName}}
          </p>
        </div>
      </div>
      <button type="button" class="pn-dialog-close" (click)="closeNotificationDialog()" aria-label="Close">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="pn-dialog-body">
      <section class="pn-dialog-section pn-preview-subject" aria-labelledby="preview-subject-label">
        <span class="pn-dialog-label" id="preview-subject-label">Subject</span>
        <p class="pn-dialog-subject" [title]="selectedNotification.subject">{{selectedNotification.subject}}</p>
      </section>

      <div class="pn-preview-summary" aria-label="Notification summary">
        <div class="pn-preview-summary-item">
          <i class="fa fa-users" aria-hidden="true"></i>
          <span>Recipients</span>
          <strong>{{selectedNotification.emailsArr?.length || 0}}</strong>
        </div>
        <div class="pn-preview-summary-item">
          <i class="fa fa-paperclip" aria-hidden="true"></i>
          <span>Attachments</span>
          <strong>{{selectedNotification.attachmentList?.length || 0}}</strong>
        </div>
      </div>

      <section class="pn-dialog-section" aria-labelledby="preview-recipients-label">
        <span class="pn-dialog-label" id="preview-recipients-label">Recipients</span>
        <div class="pn-dialog-recipients">
          <span class="pn-recipient-chip" *ngFor="let email of selectedNotification.emailsArr">{{email}}</span>
          <span *ngIf="!selectedNotification.emailsArr.length">No recipients recorded.</span>
        </div>
      </section>

      <section class="pn-dialog-section" aria-labelledby="preview-message-label">
        <span class="pn-dialog-label" id="preview-message-label">Message</span>
        <div class="pn-dialog-message" *ngIf="selectedNotification.body; else noRecordedMessage" [innerHTML]="selectedNotification.body"></div>
        <ng-template #noRecordedMessage><p>No message recorded.</p></ng-template>
      </section>

      <section class="pn-dialog-section"
        aria-labelledby="preview-attachments-label">
        <span class="pn-dialog-label" id="preview-attachments-label">Attachments</span>
        <ul class="pn-dialog-attachments">
          <li *ngFor="let file of selectedNotification.attachmentList">
            <i class="fa fa-paperclip" aria-hidden="true"></i> {{file}}
          </li>
        </ul>
        <p *ngIf="!selectedNotification.attachmentList.length">No attachments recorded.</p>
      </section>
    </div>
    <div class="pn-dialog-footer">
      <button type="button" class="btn btn-toyota-outline" (click)="closeNotificationDialog()">Close details</button>
    </div>
  </div>
</ng-template>
